import { Link } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import { Breadcrumbs as MuiBreadcrumbs } from "@mui/material";
import HomeIcon from '@mui/icons-material/Home';

// Material Dashboard 2 React components
import MDTypographyRoot from '../MDTypography/MDTypographyRoot';
import MDBoxRoot from "../MDBox/MDBoxRoot";

function Breadcrumbs({theme, title, route}) {

  const routes = route.slice(0, -1);
  const palette = theme?.palette;
  const color = palette?.light?.main ? palette.light.main : "grey";
  const isEditEvent = route[route.length - 1].match(/^\d+$/);
  let accumulatedPath = '';
  return (
    <MDBoxRoot mr={{ xs: 0, xl: 8 }} width="100%"  key='BrdCrm'>
      <MuiBreadcrumbs
        sx={{
          "& .MuiBreadcrumbs-separator": {
            color:{color},
          },
        }}
        key='BreadCrm'>
        <Link to="/" key="home">
            <HomeIcon  sx={{ lineHeight: 0,color: {color},opacity:0.7}}/>
        </Link>
        {routes.map((el) => {
        accumulatedPath += `/${el}`;
        return (
          <>

          <Link to={accumulatedPath} key={el}>

            <MDTypographyRoot
              fontWeight="regular"
              textTransform="capitalize"
              ownerState={{
                color:"light",
                opacity:0.7}}
              sx={{ lineHeight: 0,}}
            >
              {el}
            </MDTypographyRoot>
          </Link>
          </>
        )})}
        <MDTypographyRoot
          variant="button"
          fontWeight="regular"
          ownerState={{
                  color:"light",
                  opacity:0.7,
                  textTransform:"capitalize"}}
          
          sx={{ lineHeight: 0,}}
        >
          {isEditEvent ? "Info" : title?.replace("-", " ")}
        </MDTypographyRoot>
      </MuiBreadcrumbs>
    </MDBoxRoot>
  );
}

// Setting default values for the props of Breadcrumbs
Breadcrumbs.defaultProps = {
  light: false,
};

// Typechecking props for the Breadcrumbs
Breadcrumbs.propTypes = {
  icon: PropTypes.node,
  child: PropTypes.string,
  title: PropTypes.string.isRequired,
  route: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  light: PropTypes.bool,
};

export default Breadcrumbs;
